import {
  AfterViewInit,
  Component,
  Input,
  Renderer2,
  HostBinding,
  OnInit,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';

import { PageMetaService, NavigationMenuService } from '@fcom/common/services';
import { GlobalBookingActions } from '@fcom/common/store';
import { AppState, ORIGIN_SELECTOR_CONFIG } from '@fcom/core';
import { LanguageService } from '@fcom/ui-translate';
import { CmsPage } from '@fcom/core-api';

@Component({
  selector: 'cms-page',
  template: '<ng-content />',
  standalone: false,
})
export class CmsPageComponent implements AfterViewInit, OnInit, OnChanges {
  private pageMetaService = inject(PageMetaService);
  private renderer = inject(Renderer2);
  private navigationMenuService = inject(NavigationMenuService);
  private activatedRoute = inject(ActivatedRoute);
  private store$ = inject<Store<AppState>>(Store);
  private languageService = inject(LanguageService);

  @Input()
  content: CmsPage;

  @HostBinding('class.is-hidden') defaultClass = true;

  ngOnInit(): void {
    if (typeof this.content.isHeaderVisible !== 'undefined') {
      this.navigationMenuService.setHeaderVisibility(this.content.isHeaderVisible);
    }
    if (typeof this.content.isFooterVisible !== 'undefined') {
      this.navigationMenuService.setFooterVisibility(this.content.isFooterVisible);
    }
  }

  ngAfterViewInit(): void {
    this.pageMetaService.setTitle(this.content.seoTitle || this.content.title);
    this.pageMetaService.moveMetaAndLinksToHead(this.content.metaData, this.renderer);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content']) {
      const originFromQuery = this.activatedRoute.snapshot.queryParamMap.get('origin')?.toUpperCase();
      const countryCode = this.languageService.ddsLocaleValue?.countrySite?.toUpperCase() ?? 'INT';
      const allowedOrigins = ORIGIN_SELECTOR_CONFIG[countryCode];
      const isValidOrigin = !!originFromQuery && !!allowedOrigins?.includes(originFromQuery);
      const originCode = isValidOrigin ? originFromQuery : (this.content.defaultOriginLocationCode ?? 'HEL');
      this.pageMetaService.setDefaultOriginLocationCode(originCode);
      if (originFromQuery) {
        // Dispatch the resolved origin so the booking widget shows the correct origin
        // without falling back to geolocation: either the valid param or the site default.
        this.store$.dispatch(GlobalBookingActions.setOrigin({ origin: originCode }));
      }
      this.pageMetaService.setTitle(this.content.seoTitle || this.content.title);
      // Make the pageMetaService to sync the latest metaData
      this.pageMetaService.moveMetaAndLinksToHead(this.content.metaData, this.renderer);
    }
  }
}
